import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExperianIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 8,
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_16636_7059)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M25.7201 12.0095H23.0142C22.2025 12.0095 21.5446 12.6677 21.5446 13.4796V16.1848C21.5446 16.9966 22.2025 17.6548 23.0142 17.6548H25.7201C26.5318 17.6548 27.1897 16.9966 27.1897 16.1848V13.4796C27.1897 12.6677 26.5318 12.0095 25.7201 12.0095Z",
					fill: "#406EB3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.7379 17.4072H15.623C14.732 17.4072 14.0096 18.1298 14.0096 19.0211V22.1353C14.0096 23.0266 14.732 23.7492 15.623 23.7492H18.7379C19.629 23.7492 20.3513 23.0266 20.3513 22.1353V19.0211C20.3513 18.1298 19.629 17.4072 18.7379 17.4072Z",
					fill: "#632678"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.3993 26.2371H16.5575C16.0017 26.2371 15.5511 26.6878 15.5511 27.2437V29.0861C15.5511 29.642 16.0017 30.0927 16.5575 30.0927H18.3993C18.9551 30.0927 19.4057 29.642 19.4057 29.0861V27.2437C19.4057 26.6878 18.9551 26.2371 18.3993 26.2371Z",
					fill: "#982881"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.4215 31.3853H21.1851C20.5323 31.3853 20.0031 31.9146 20.0031 32.5677V34.8047C20.0031 35.4577 20.5323 35.9871 21.1851 35.9871H23.4215C24.0743 35.9871 24.6035 35.4577 24.6035 34.8047V32.5677C24.6035 31.9146 24.0743 31.3853 23.4215 31.3853Z",
					fill: "#BA2F7D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.4995 15.616H29.9692C29.5193 15.616 29.1545 15.9808 29.1545 16.4309V17.96C29.1545 18.4101 29.5193 18.775 29.9692 18.775H31.4995C31.9494 18.775 32.3142 18.4101 32.3142 17.96V16.4309C32.3142 15.9808 31.9494 15.616 31.4995 15.616Z",
					fill: "#BA2F7D"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M30.5219 25.7384C30.4979 25.7639 30.4724 25.7639 30.4484 25.7639C30.4228 25.7639 23.808 25.7639 23.808 25.7639C24.0572 27.1573 25.2505 28.1511 26.7169 28.1511C27.4884 28.1511 28.2105 27.9019 28.7072 27.381C28.8558 27.2068 29.0555 27.0822 29.2791 27.0822C29.6529 27.0822 29.9995 27.4049 29.9995 27.8028C29.9995 28.0025 29.9005 28.2262 29.7519 28.3509C28.9564 29.1466 27.8622 29.594 26.6929 29.594C24.2553 29.594 22.2905 27.6542 22.2905 25.1919C22.2905 22.7791 24.2314 20.8137 26.6929 20.8137C29.0555 20.8137 31.0442 22.704 31.0698 24.9426C31.0698 25.3165 30.8206 25.6137 30.5219 25.7384ZM23.8831 24.2955H29.4788C29.105 23.1019 28.0108 22.2566 26.6929 22.2566C25.3495 22.2566 24.2553 23.1019 23.8831 24.2955Z",
					fill: "#26478D"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_16636_7059",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 18.3221,
				height: 24,
				fill: "white",
				transform: "translate(14 12)"
			})
		}) })
	]
});
export default SvgExperianIcon;
